import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ModuleHeader from "./ModuleHeader";
import ReactEcharts from "echarts-for-react";
import SystemMangeIcon from "@/assets/img/lcg/system-mange-icon.webp";
import SystemMangeBg from "@/assets/img/lcg/system-mange-bg.webp";
import { lcgApi } from "@/api/lcgApi";
import { REM_CONFIG } from "@/utils/fontSize";
const LowConsumptionRatio = ({ className = "", }) => {
    const [dataSource, setDataSource] = useState();
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await lcgApi.useProportion();
            setDataSource(res.data);
        }
        catch (error) {
            console.error("获取部门数据失败:", error);
            // 可以设置默认数据或错误处理
        }
    };
    const getEchartsOption = () => ({
        renderer: "canvas",
        tooltip: {
            trigger: "item",
            formatter: function (param) {
                return `${param.marker}${param.name}: ${param.value}%`;
            },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        legend: {
            orient: "horizontal",
            bottom: "2%",
            left: "center",
            textStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
            },
            itemGap: 20, // 增加图例项之间的间距
            itemWidth: 12,
            itemHeight: 12,
            data: ["低耗", "耗材"],
        },
        series: [
            {
                type: "pie",
                radius: ["79.5%", "80%"],
                center: ["50%", "45%"], // 向上移动中心点，为图例留出空间
                data: [
                    {
                        value: 100,
                        itemStyle: { color: "#183256", borderWidth: 0 },
                    },
                ],
                label: { show: false },
                labelLine: { show: false },
                hoverAnimation: false,
            },
            {
                name: "低耗占比",
                type: "pie",
                radius: ["40%", "50%"],
                center: ["50%", "45%"], // 向上移动中心点，为图例留出空间
                startAngle: 160,
                data: [
                    {
                        value: dataSource?.useRadio || 41,
                        name: "低耗",
                        itemStyle: { color: "#1677FF" },
                    },
                    {
                        value: dataSource?.availStockRadio || 59,
                        name: "耗材",
                        itemStyle: { color: "#27D8F5" },
                    },
                ],
                label: {
                    show: true,
                    position: "outside",
                    formatter: (params) => {
                        return `{title|${params.value}%}\n{value|${params.name}}`;
                    },
                    rich: {
                        title: {
                            fontSize: REM_CONFIG.fontSize.small,
                            color: (p) => p.color,
                            lineHeight: 20,
                        },
                        value: {
                            fontSize: REM_CONFIG.fontSize.small,
                            fontWeight: "bold",
                            color: "#fff",
                            lineHeight: 20,
                        },
                    },
                },
                labelLine: {
                    show: true,
                    length: 20, // 缩短标签线长度
                    length2: 50, // 第二段长度
                    lineStyle: {
                        color: "rgba(255, 255, 255, 0.7)",
                        width: 1,
                    },
                },
                // 添加标签布局配置，避免重叠
                labelLayout: {
                    hideOverlap: true, // 隐藏重叠的标签
                    moveOverlap: "shiftY", // 移动重叠的标签
                    draggable: true, // 允许拖动标签
                },
                // 添加emphasis配置，突出显示
                emphasis: {
                    label: {
                        show: true,
                        fontWeight: "bold",
                    },
                },
            },
        ],
        // 添加网格配置，确保图表内容不会超出边界
        grid: {
            top: "80",
            bottom: "", // 为底部图例留出足够空间
            left: "",
            right: "",
        },
    });
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u4F4E\u8017\u5360\u6BD4" }), _jsxs("div", { className: "flex-1 min-h-0 flex items-center justify-center relative", children: [_jsx(ReactEcharts, { option: getEchartsOption(), style: { width: "100%", height: "100%" }, opts: { renderer: "canvas" } }), _jsx("img", { src: SystemMangeBg, alt: "\u80CC\u666F\u56FE", style: {
                            position: "absolute",
                            left: "50%",
                            top: "45%", // 与图表中心点对齐
                            transform: "translate(-50%, -50%)",
                            width: "0.96rem",
                            height: "0.96rem",
                            zIndex: 999, // 低于图标
                        } }), _jsx("img", { src: SystemMangeIcon, alt: "\u7CFB\u7EDF\u7BA1\u7406\u56FE\u6807", style: {
                            position: "absolute",
                            left: "50%",
                            top: "45%", // 与图表中心点对齐
                            transform: "translate(-50%, -50%)",
                            width: "0.60rem", // 图标尺寸（根据设计调整）
                            height: "0.60rem",
                            zIndex: 1000, // 高于背景图
                        } })] })] }));
};
export default LowConsumptionRatio;
